import React from 'react'

const Collab = () => {
    return (
        <div className="collab-container">
            <div className="collab-heading">Interested in working together?</div>
            <div className="collab-info">You can trust me for project collaboration. I try to deliver the best in every project.</div>
            <div className="contact-btn btn">Contact Me</div>
        </div>
    )
}

export default Collab
